import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PedidoVisualizar from '../components/pedido/PedidoVisualizar';

const PedidoVisualizarPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom 
          sx={{ 
            fontWeight: 'bold',
            fontFamily: 'Arial, sans-serif',
            fontSize: '2.125rem',
            lineHeight: 1.235
          }}
        >
          Visualizar Pedido
        </Typography>
      </Box>
      <PedidoVisualizar />
    </Container>
  );
};

export default PedidoVisualizar;
